
export enum KpiType {
  Aggregation = 'Aggregation',
  Binary      = 'Binary',
}
